module.exports = __webpack_public_path__ + "img/header-memoireRingsBudgetHigh.b47f1b8.webp";